<template>
  <v-fade-transition>
    <div style="margin-top:100px;margin-bottom:50px">
      <v-row justify="center">
        <div class="slotMachine">
          <div class="slotMachine-reels">
            <div class="slotMachine-shadow"></div>
            <div class="slotMachine-payline"></div>
            <slot-reel ref="reel1" :canlock="canlock" v-on:stopped="reelStopped"></slot-reel>
            <slot-reel ref="reel2" :canlock="canlock" v-on:stopped="reelStopped"></slot-reel>
            <slot-reel ref="reel3" :canlock="canlock" v-on:stopped="reelStopped"></slot-reel>
          </div>
          <v-row class="mt-8"></v-row>
        </div>
      </v-row>
      <v-row justify="center">
        <v-btn
          x-large
          v-on:mousedown="spin()"
          class="text-none warning"
          style="font-size:20px;animation: zoominout 1s;animation-iteration-count: 1;"
          rounded
        >Play ({{ user.credits }}⭐)</v-btn>
        <!-- <v-btn
          fab
          large
          @click="$store.commit('setDialogPrizes', true)"
          class="text-none primary ml-4"
        >
          <v-avatar size="30" tile>
            <v-img src="/img/prize.svg"></v-img>
          </v-avatar>
        </v-btn>-->
      </v-row>
      <v-row
        justify="center"
        @click="$store.commit('setDialogPrizes', true)"
        class="mt-5 white--text"
        style="text-decoration:underline;cursor:pointer"
      >
        Prizes
        <!-- <v-avatar size="15" tile class="mt-1 ml-1">
          <v-img src="/img/prize.svg"></v-img>
        </v-avatar>-->
      </v-row>
      <v-btn
        v-if="wonBeer"
        color="primary"
        @click="showReward()"
        fab
        large
        dark
        style="animation: zoominout 1s infinite; position:fixed;top: 15px; left:15px"
      >
        <v-avatar size="58" tile>
          <v-img :src="reelSourceData[2].slotMachineRewardUrl"></v-img>
        </v-avatar>
      </v-btn>
    </div>
  </v-fade-transition>
</template>

<script>
import SlotReel from "../components/SlotReel.vue";
import { mapState } from "vuex";

export default {
  components: {
    SlotReel
  },
  computed: {
    ...mapState(["user", "reelSourceData"])
  },
  data: function() {
    return {
      wonBeer: false,
      resultData: false,
      canlock: true,
      waslocked: false,
      audio: {
        barWin: new Audio(
          "https://freesound.org/data/previews/337/337049_3232293-lq.mp3"
        ),
        win: new Audio(
          "https://freesound.org/data/previews/387/387232_1474204-lq.mp3"
        ),
        insertCoin: new Audio(
          "https://freesound.org/data/previews/276/276091_5123851-lq.mp3"
        ),
        bigwin: new Audio(
          "https://freesound.org/data/previews/270/270319_5123851-lq.mp3"
        )
      }
    };
  },
  beforeMount: function() {},
  methods: {
    showReward() {
      this.$store.commit("setReward", {
        overlay: true,
        src: this.reelSourceData[2].slotMachineRewardUrl,
        value: 0,
        name: "Beer"
      });
    },
    spin: function() {
      if (this.user.credits == 0) {
        if (!this.user.emailSent) {
          this.$store.commit("setDialogContact", true);
        } else {
          this.$store.commit("setSnackbar", {
            color: "warning",
            timeout: 5000,
            text:
              "No more star 😕. Refill up this cup at any location to get more stars ⭐⭐⭐"
          });
        }
        return;
      }
      if (this.user.credits > 0 && !this.resultData) {
        this.resultData = [];
        this.$store.dispatch("updateUserCredits", -1);
        this.$refs.reel1.run();
        this.$refs.reel2.run();
        this.$refs.reel3.run();
      } else {
        this.$store.commit("setSlotMachineIsRunning", false);
      }
    },
    insertCoin: function() {
      this.audio.insertCoin.currentTime = 0;
      this.audio.insertCoin.play();
      this.$store.dispatch("updateUserCredits", 1);
    },
    reelStopped(resultData, wasLocked) {
      if (wasLocked) this.waslocked = wasLocked;
      this.resultData.push(resultData);
      if (this.resultData.length === 3) {
        this.checkWin(this.resultData);
        if (this.waslocked) {
          this.waslocked = false;
          this.canlock = false;
        } else {
          this.canlock = true;
        }
      }
    },
    checkWin: function() {
      if (this.resultData.length === 3) {
        // ;-)
        const v1 = this.resultData[0];
        const v2 = this.resultData[1];
        const v3 = this.resultData[2];

        if (v1.name === v2.name && v2.name === v3.name) {
          this.$store.commit("setReward", {
            overlay: true,
            src: v1.slotMachineRewardUrl,
            value: v1.value,
            name: v1.name
          });
          if (v1.name == "Beer") {
            this.wonBeer = true;
          }
          if (v1.value >= 8) {
            this.audio.bigwin.play();
          } else {
            this.audio.win.play();
          }
          this.$store.dispatch("updateUserCredits", v1.value);
          this.waslocked = true; // prevent lock after an unlocked win
        } else {
          const bar1 = v1.name === "Bar";
          const bar2 = v2.name === "Bar";
          const bar3 = v3.name === "Bar";
          if ((bar1 && bar2) || (bar1 && bar3) || (bar2 && bar3)) {
            this.audio.bigwin.play();
            this.$store.dispatch("updateUserCredits", 18);
            this.$store.commit("setReward", {
              overlay: true,
              src: this.reelSourceData[4].slotMachineRewardUrl,
              value: 18,
              name: "Bar"
            });
            this.waslocked = true; // prevent lock after an unlocked win
          } else if (bar1 || bar2 || bar3) {
            // this.audio.win.play()
            // this.audio.barWin.play()
            this.$store.dispatch("updateUserCredits", 3);
            this.$store.commit("setReward", {
              overlay: true,
              src: this.reelSourceData[4].slotMachineRewardUrl,
              value: 3,
              name: "Bar"
            });

            this.waslocked = true; // prevent lock after an unlocked win
          } else {
            // Lose : (
          }
        }
      }
      this.$store.commit("setSlotMachineIsRunning", false);

      this.resultData = false;
    }
  }
};
</script>

<style lang="postcss">
/* * {
  border: solid 1px red;
} */
/* @use postcss-cssnext; */
:root {
  --tileSize: 90px;
}
.slotMachine {
  border-radius: 5px;
  width: calc(var(--tileSize) * 3);
}
.slotMachine-reels {
  display: flex;
  position: relative;
}
.slotMachine-shadow {
  border-radius: 10px;
  pointer-events: none;
  z-index: 99;
  position: absolute;
  width: 100%;
  height: 100%;
  box-shadow: inset 0 25px 30px -5px rgba(128, 128, 128, 0.2),
    inset 0 -25px 30px -5px rgba(128, 128, 128, 0.2),
    inset 0 5px 10px -2px rgba(128, 128, 128, 0.4),
    inset 0 -5px 10px -2px rgba(128, 128, 128, 0.4);
}
.slotMachine-payline {
  position: absolute;
  top: calc(var(--tileSize) * 1 * 1.1666);
  height: 1px;
  width: 100%;
  background: rgba(128, 128, 128, 0.2);
}

.slotMachine-stats {
  display: flex;
  background: #d4f8e8;
  justify-content: flex-end;
  padding: 10px 0;
  border-radius: 0 0 5px 5px;
}
.slotMachine-coin {
  width: 6px;
  height: 38px;
  background: rgba(128, 128, 128, 0.2);
  border: 3px solid rgba(128, 128, 128, 0.4);
  border-radius: 6px;
  margin: 12px 10px 0 10px;
}
.slotMachine-stat {
  display: flex;
  flex-direction: column;
  margin-right: 10px;
  flex-grow: 1;
}
.slotMachine-statTitle {
  font-size: 12px;
  color: #413f41;
}
.slotMachine-statValue {
  padding: 5px 10px;
  border-radius: 2px;
  border: 1px solid rgba(128, 128, 128, 1);
  font-size: 25px;
  text-align: right;
  color: #1eb2a6;
  white-space: nowrap;
}
.slotMachine-statSub {
  font-size: 9px;
  color: #413f41;
  text-align: right;
}
</style>
